import { FC } from 'react';
import { CatPagination } from '@blocks-react/components/Pagination';
import { NotificationPaginationProps } from '../types';
import styles from '../NotificationDrawer.module.scss';

export const NotificationCatPagination: FC<NotificationPaginationProps> = ({
  pageSize,
  handlePageChange,
  totalRecords,
  currentPage,
  className = 'mt-4'
}) => {
  return (
    <CatPagination
      totalRecords={totalRecords}
      pageSize={pageSize}
      onBlPageChange={handlePageChange}
      currentItem={currentPage}
      data-testid="Notification-Pagination"
      className={`${className} ${styles['notification-footer--pagination']}`}
      hidePageSize={true}
      variant="in-page"
    />
  );
};
